var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentfailed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4205_4350",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 54,
    height: 54
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 52C40.8075 52 52 40.8075 52 27C52 13.1925 40.8075 2 27 2C13.1925 2 2 13.1925 2 27C2 40.8075 13.1925 52 27 52Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0712 19.9287L19.9287 34.0712M19.9287 19.9287L34.0712 34.0712",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4205_4350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3 -3H57V57H-3V-3Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentfailed);
export default __webpack_public_path__ + "static/media/paymentfailed.4f90864c9d78a2cecf68e91ffe4cea0f.svg";
export { ForwardRef as ReactComponent };